import React from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { MenuHeader } from "../settings/MenuHeader";
import {
  Divider,
  InputLabel,
  SettingInput,
  SettingMenu,
  SettingOption
} from "../settings/styles";
import { TopLevelSettingOption } from "../settings/TopLevelSettings";

type OptionsProps = {
  abrLabel: string;
  onClickBack: () => void;
  onBlur: (event) => void;
};

export const VideoTracksOptions = ({
  abrLabel,
  onBlur,
  onClickBack
}: OptionsProps) => {
  const { useStoreState } = usePlayerStore();
  const isAdaptiveBitRate = useStoreState.isAdaptiveBitrate();
  const selectedVideoTrack = useStoreState.selectedVideoTrack();
  const uiSize = useStoreState.uiSize();
  const videoTracks = useStoreState.videoTracks();

  const setUserPreferredVideoTrack = useStoreState.setUserPreferredVideoTrack();

  return (
    <>
      <MenuHeader backToTopLevel={onClickBack} label="laatu" />
      <Divider />
      <SettingMenu role="menu">
        <SettingOption key="auto">
          <SettingInput
            checked={isAdaptiveBitRate}
            id="video-track-setting-auto"
            name="video-track"
            onBlur={onBlur}
            onChange={() =>
              setUserPreferredVideoTrack({ bitrate: "auto", label: "auto" })
            }
            onClick={onClickBack}
          />
          <InputLabel htmlFor="video-track-setting-auto" uiSize={uiSize}>
            {abrLabel}
          </InputLabel>
        </SettingOption>
        {videoTracks
          ?.filter(item => !item.hidden)
          .map((item, i) => (
            <SettingOption key={i}>
              <SettingInput
                checked={
                  // To keep user in similiar bitrate we compare labels instead of bitrate
                  selectedVideoTrack?.label === item.label && !isAdaptiveBitRate
                }
                id={`video-track-setting-${i}`}
                name="video-track"
                onBlur={onBlur}
                onChange={() =>
                  setUserPreferredVideoTrack({
                    bitrate: item.bitrate,
                    label: item.label
                  })
                }
                onClick={onClickBack}
                value={i}
              />
              <InputLabel htmlFor={`video-track-setting-${i}`} uiSize={uiSize}>
                {item.label}
              </InputLabel>
            </SettingOption>
          ))}
      </SettingMenu>
    </>
  );
};

type TopLevelOptionProps = {
  abrLabel: string;
  onBlur: (event: React.FocusEvent<HTMLElement>) => void;
  onClick: () => void;
};

export const VideoTracksTopLevelOption = ({
  abrLabel,
  onBlur,
  onClick
}: TopLevelOptionProps) => {
  const { useStoreState } = usePlayerStore();
  const isAdaptiveBitRate = useStoreState.isAdaptiveBitrate();
  const selectedVideoTrack = useStoreState.selectedVideoTrack();

  const { language } = useEmbedParametersContext();

  return (
    <TopLevelSettingOption
      onBlur={onBlur}
      onClick={onClick}
      title={i18n("laatu", { language })}
      value={isAdaptiveBitRate ? abrLabel : selectedVideoTrack?.label}
    />
  );
};
